import { inject, Injectable } from '@angular/core';
import { QueryParamsHandling, Router } from '@angular/router';
import { GestionProvenanceService } from './gestion-provenance.service';
import { Routes } from 'src/app/constantes/routes.enum';
import { TypeModificationEnum } from 'src/app/constantes/type-modification.enum';
import { ActionDGAGEnum } from 'src/app/constantes/action-dgag.enum';
import { ContexteModificationEnum } from '../../constantes/contexte-modification.enum';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router = inject(Router);
  private readonly gestionProvenanceService = inject(GestionProvenanceService);
  constructor() {}

  naviguerVersCoordonnees() {
    this.router
      .navigate([Routes.COORDONNEES], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersCoordonneesSurRefresh(queryParams?: string) {
    this.router.navigateByUrl(Routes.COORDONNEES + queryParams).then();
  }

  naviguerVersModifierCourriel() {
    this.router
      .navigate([Routes.MODIFIER_COURRIEL], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }
  naviguerVersModifierAdresse() {
    this.router
      .navigate([Routes.MODIFIER_ADRESSE], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }
  naviguerVersModifierAdresseAssurances() {
    this.router
      .navigate([Routes.MODIFIER_ADRESSE], {
        fragment: 'assurances',
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }
  naviguerVersModifierTelephone() {
    this.router
      .navigate([Routes.MODIFIER_TELEPHONE], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersValidationCourriel() {
    this.router
      .navigate([Routes.VALIDATION_COURRIEL], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }
  naviguerVersValidationAdresse() {
    this.router
      .navigate([Routes.VALIDATION_ADRESSE], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersValidationTelephone() {
    this.router
      .navigate([Routes.VALIDATION_TELEPHONE], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersConfirmationAdresse(
    contexteDGAG: ActionDGAGEnum | undefined,
    estDGAGApparie: boolean,
  ) {
    this.router
      .navigate([Routes.CONFIRMATION_ADRESSE], {
        state: { DGAG: contexteDGAG, estDGAGApparie: estDGAGApparie },
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersConfirmationCourriel(typeModification: TypeModificationEnum) {
    this.router
      .navigate([Routes.CONFIRMATION_COURRIEL], {
        state: { typeModification: typeModification },
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersConfirmationTelephone(typeModification: TypeModificationEnum) {
    this.router
      .navigate([Routes.CONFIRMATION_TELEPHONE], {
        state: { typeModification: typeModification },
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersPageErreur(
    status?: string,
    codeErreur?: string,
    messageErreur?: string,
    context?: ContexteModificationEnum,
  ) {
    this.router
      .navigate([Routes.ERREUR], {
        state: {
          status: status,
          codeErreur: codeErreur,
          messageErreur: messageErreur,
          context: context,
        },
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersFinParcours(status?: string, codeErreur?: string, messageErreur?: string) {
    this.router
      .navigate([Routes.FIN_PARCOURS], {
        state: {
          status: status,
          codeErreur: codeErreur,
          messageErreur: messageErreur,
        },
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  obtenirValeurQueryParamsHandling(): QueryParamsHandling | null {
    return this.gestionProvenanceService.obtenirValeurQueryParamsHandling();
  }
}
